import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import { useMemo } from 'react';

import { SearchResultTab } from './search-result-tab.component';

import { SearchResult } from '@/app/(main)/_components/search-modal/search-modal.types';
import { EnvironmentNameEnum, getEnvironmentNameFromUrl } from '@/config/environment';
import { SelectedProcedures } from '@/app/(main)/_components/search-modal/search-modal.types';
import { mostSearchedProceduresElasticTest } from '@/app/(main)/_components/search-modal/_consts/most-searched-procedures-elastic-test.consts';
import { mostSearchedProceduresElasticProd } from '@/app/(main)/_components/search-modal/_consts/most-searched-procedures-elastic-prd.consts';
import { mostSearchedProceduresElasticHml } from '@/app/(main)/_components/search-modal/_consts/most-searched-procedures-elastic-hml.consts';
import { Typography } from '@/components/ui/typography/typography.component';
import { SearchModalListEnum } from '@/types/enums/analytics/home/home-analytics.enum';
import { OverridedUserLocation } from '@/utils/formatters/city/format-place-from-slug.const';

const mostSearchedByEnvironment: Partial<Record<EnvironmentNameEnum, SearchResult[]>> = {
  [EnvironmentNameEnum.PRODUCTION]: mostSearchedProceduresElasticProd,
  [EnvironmentNameEnum.HOMOLOG]: mostSearchedProceduresElasticHml,
};

interface MostSearchedProps {
  setOpen: (open: boolean) => void;
  selectLaboratoryProcedure?: (procedure: SelectedProcedures) => void;
  locationOverride?: OverridedUserLocation;
}

export const MostSearched = ({ setOpen, selectLaboratoryProcedure, locationOverride }: MostSearchedProps) => {
  const mostSearchedProcedures: SearchResult[] = useMemo(() => {
    if (typeof window === 'undefined') {
      return mostSearchedProceduresElasticTest;
    }
    return mostSearchedByEnvironment[getEnvironmentNameFromUrl()] ?? mostSearchedProceduresElasticTest;
  }, []);

  return (
    <div data-testid={DataTestIdEnum.PROCEDURES_MODAL_MOST_SEARCHED}>
      <Typography className="font-semibold px-6">
        Mais procurados
      </Typography>
      <div>
        {mostSearchedProcedures.map((procedure, index) => (
          <div key={procedure.id} className="hover:bg-gray-50 transition-colors">
            <SearchResultTab
              {...procedure}
              list={SearchModalListEnum.MOST_SEARCHED}
              position={index + 1}
              totalResults={mostSearchedProcedures.length}
              setOpen={setOpen}
              selectLaboratoryProcedure={selectLaboratoryProcedure}
              locationOverride={locationOverride}
            />
            <hr />
          </div>
        ))}
      </div>
    </div>
  );
};
